import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class InsurerReportingsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/insurer_reportings", { params: toSnakeCase(params) });
  }

  update(id, data) {
    return securedAxiosInstance.put(`/insurer_reportings/${id}`, toSnakeCase(data));
  }

  downloadQontoBulkTransferCSV(payload) {
    return securedAxiosInstance.post("/insurer_reportings/qonto_bulk_transfer.csv", toSnakeCase(payload));
  }
}

export default new InsurerReportingsService();
